var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumeracion224X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#80CFBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.272 15.552C10.296 14.6667 11.1013 13.9413 11.688 13.376C12.2853 12.8 12.7813 12.2027 13.176 11.584C13.5707 10.9653 13.768 10.3467 13.768 9.72799C13.768 9.08799 13.6133 8.58666 13.304 8.22399C13.0053 7.86132 12.5307 7.67999 11.88 7.67999C11.2507 7.67999 10.76 7.88266 10.408 8.28799C10.0667 8.68266 9.88534 9.21599 9.864 9.88799H8.104C8.136 8.67199 8.49867 7.74399 9.192 7.10399C9.896 6.45332 10.7867 6.12799 11.864 6.12799C13.0267 6.12799 13.9333 6.44799 14.584 7.08799C15.2453 7.72799 15.576 8.58132 15.576 9.64799C15.576 10.416 15.3787 11.1573 14.984 11.872C14.6 12.576 14.136 13.2107 13.592 13.776C13.0587 14.3307 12.376 14.976 11.544 15.712L10.824 16.352H15.896V17.872H8.12V16.544L9.272 15.552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeracion224X24);
export default __webpack_public_path__ + "static/media/NUMERACION 2_24X24.b4768ff0036ff7a280cdb3fb3292eee4.svg";
export { ForwardRef as ReactComponent };